import { ROUTES } from '#/config/routes';

function formatRequiredQtyForQuery(requiredQty) {
  const n = Number(requiredQty);
  if (!Number.isFinite(n) || n <= 0) {
    return null;
  }
  return String(n);
}

/**
 * 用料需求列 → 工單建立頁 deep link。
 * manufacturing_qty = requiredQty；mtr_id 優先，否則 mtr_no。
 * 可選 mtr_name、from_work_order_id（未匹配 BOM 時 toast／導回詳情用）。
 *
 * @param {object} row
 * @param {{ fromWorkOrderId?: string }} [options]
 */
export function buildWorkOrderCreateUrlFromRequirement(row, options = {}) {
  const params = new URLSearchParams();

  const manufacturingQty = formatRequiredQtyForQuery(row?.requiredQty);
  if (manufacturingQty) {
    params.set('manufacturing_qty', manufacturingQty);
  }

  const mtrId = row?.mtr?.id ?? row?.mtrId;
  const mtrNo = row?.mtr?.mtrNo ?? row?.mtrNo;
  const mtrName = row?.mtr?.name;

  if (mtrId) {
    params.set('mtr_id', String(mtrId));
  } else if (mtrNo) {
    params.set('mtr_no', String(mtrNo));
  }

  if (mtrName != null && String(mtrName).trim() !== '') {
    params.set('mtr_name', String(mtrName).trim());
  }

  if (options.fromWorkOrderId) {
    params.set('from_work_order_id', String(options.fromWorkOrderId));
  }

  const query = params.toString();
  return query ? `${ROUTES.workOrderCreate}?${query}` : ROUTES.workOrderCreate;
}
